import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from "../authentication.service";

/// This class prevents someone from loading the login page if they are
/// already logged in.
export const LoginGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>  {

    const router = inject(Router);
    const authService = inject(AuthenticationService);


    if (authService.currentUser() == null) {
        return true;
    }

    // Already logged in? Head to the dashboard page.
    router.navigate(['/']);
    return false;
}
